module.exports = __webpack_public_path__ + "media/vo-03-04.6ea4c32f.mp3";